<div class="content-area">

    <mat-card class="summary-card" [class.trip-mode]="isTripContext">
        <!-- Modern/Home-Aligned Structure -->

        <!-- Header Row -->
        <div class="card-modern-header">
            <!-- FAMILY MODE HEADER -->
            <ng-container *ngIf="!isTripContext">
                <span class="card-label-small">
                    {{ reportScope === 'month' ? 'MONTHLY REPORT' : 'ANNUAL REPORT' }}
                </span>

                <!-- Compact Month Nav -->
                <div class="compact-date-nav" *ngIf="reportScope === 'month'">
                    <button mat-icon-button class="icon-nav-btn" (click)="changeReportMonth(-1)">
                        <mat-icon>chevron_left</mat-icon>
                    </button>
                    <span class="nav-date-text">{{ reportMonth + '-01' | date:'MMM yyyy' }}</span>
                    <button mat-icon-button class="icon-nav-btn" (click)="changeReportMonth(1)">
                        <mat-icon>chevron_right</mat-icon>
                    </button>
                </div>

                <!-- Compact Year Nav -->
                <div class="compact-date-nav" *ngIf="reportScope === 'year'">
                    <button mat-icon-button class="icon-nav-btn" (click)="changeReportYear(-1)">
                        <mat-icon>chevron_left</mat-icon>
                    </button>
                    <span class="nav-date-text">{{ reportYear }}</span>
                    <button mat-icon-button class="icon-nav-btn" (click)="changeReportYear(1)">
                        <mat-icon>chevron_right</mat-icon>
                    </button>
                </div>
            </ng-container>

            <!-- TRIP MODE HEADER -->
            <ng-container *ngIf="isTripContext">
                <span class="card-label-small">TRIP REPORT</span>

                <!-- Trip Selector Pill -->
                <div class="trip-selector-pill" [matMenuTriggerFor]="tripMenu">
                    <span>{{ (selectedTripName | slice:0:15) || 'SELECT' }}</span>
                    <mat-icon class="selector-icon">expand_more</mat-icon>
                </div>
            </ng-container>
        </div>

        <!-- Body Row -->
        <div class="card-modern-body">

            <!-- Amount Section -->
            <div class="amount-wrapper-modern">
                <span class="currency-small">₹</span>
                <span class="amount-large">{{ currentReportStats.total | number:'1.0-0' }}</span>
            </div>

            <!-- Context / Actions Section -->

            <!-- FAMILY ACTIONS -->
            <div *ngIf="!isTripContext">
                <div class="glass-action-btn" (click)="downloadReport()" matTooltip="Download Report">
                    <mat-icon>download</mat-icon>
                </div>
            </div>

            <!-- TRIP ACTIONS -->
            <div *ngIf="isTripContext" class="trip-actions-row">
                <div class="glass-action-btn" (click)="copyTripToFamily()" matTooltip="Copy to Family" matRipple>
                    <mat-icon class="action-icon-small">send</mat-icon>
                </div>
                <div class="glass-action-btn" (click)="downloadReport()" matTooltip="Download Report" matRipple>
                    <mat-icon>download</mat-icon>
                </div>
            </div>

        </div>

        <mat-menu #tripMenu="matMenu" class="custom-trip-menu">
            <button mat-menu-item *ngFor="let trip of trips$ | async" (click)="trip.id && onTripChange(trip.id)">
                <span>{{ trip.name }}</span>
            </button>
        </mat-menu>
    </mat-card>

    <!-- View Toggle Tabs -->
    <div class="view-tabs-container">
        <mat-tab-group [(selectedIndex)]="reportTabIndex" animationDuration="0ms" appDraggableTabs>
            <mat-tab label="By Category">

                <div class="tab-content">
                    <div class="category-list">
                        <div *ngFor="let cat of currentReportStats.categories" class="category-wrapper">
                            <div class="category-item-row" (click)="toggleCategory(cat.name)"
                                [class.expanded]="expandedCategory === cat.name">
                                <div class="category-icon-small">{{ cat.name.charAt(0) }}</div>
                                <div class="category-info-col">
                                    <div class="cat-row-top">
                                        <span class="cat-name">{{ cat.name }}</span>
                                        <span class="cat-amt">{{ cat.amount | currency:'INR':'symbol':'1.0-2' }}</span>
                                    </div>
                                    <mat-progress-bar mode="determinate" [value]="cat.percentage"></mat-progress-bar>
                                </div>
                                <mat-icon class="expand-icon">{{ expandedCategory === cat.name ? 'expand_less' :
                                    'expand_more'
                                    }}</mat-icon>
                            </div>

                            <div class="drill-down-container" *ngIf="expandedCategory === cat.name">
                                <div *ngFor="let detail of cat.details" class="drill-down-item">
                                    <span class="drill-date">{{ detail.date | date:'EEE, MMM d' }}</span>
                                    <span class="drill-description">{{ detail.description }}</span>
                                    <span class="drill-amount">{{ detail.amount | currency:'INR':'symbol':'1.0-2'
                                        }}</span>
                                </div>
                            </div>
                        </div>

                        <div *ngIf="currentReportStats.categories.length === 0" class="empty-state">
                            <mat-icon class="large-empty-icon">bar_chart</mat-icon>
                            <p>No data found</p>
                        </div>
                    </div>
                </div>

            </mat-tab>
            <mat-tab label="By Time">

                <div class="tab-content">
                    <div class="daily-list">
                        <div *ngFor="let item of currentReportStats.timeline" class="daily-item-row">
                            <div class="daily-date">
                                {{ reportScope === 'month' ? (item.label | date:'EEE, d') : (item.label + '-01' |
                                date:'MMM') }}
                            </div>
                            <div class="daily-bar-col">
                                <mat-progress-bar mode="determinate" color="accent"
                                    [value]="item.percentage"></mat-progress-bar>
                            </div>
                            <div class="daily-amount">{{ item.amount | currency:'INR':'symbol':'1.0-2' }}</div>
                        </div>

                        <div *ngIf="currentReportStats.timeline.length === 0" class="empty-state">
                            <mat-icon class="large-empty-icon">calendar_today</mat-icon>
                            <p>No data found</p>
                        </div>
                    </div>
                </div>

            </mat-tab>

            <mat-tab label="Settlement" *ngIf="isTripContext">
                <div class="tab-content tab-content-padded">

                    <!-- Balances -->
                    <div class="section-header">Net Share</div>
                    <div class="balances-grid">
                        <div *ngFor="let member of memberBalances" class="balance-card"
                            [class.positive]="member.balance > 0" [class.negative]="member.balance < 0">
                            <div class="member-avatar"
                                [style.background-image]="member.photoURL ? 'url(' + member.photoURL + ')' : ''"
                                [style.background-color]="member.photoURL ? 'transparent' : '#E0E7FF'">
                                {{ member.photoURL ? '' : member.name.charAt(0) }}
                            </div>
                            <div class="balance-info">
                                <span class="b-name">{{ member.name }}</span>
                                <span class="b-status">{{ member.balance > 0 ? 'Gets back' : (member.balance < 0
                                        ? 'Owes' : 'Settled' ) }}</span>
                            </div>
                            <div class="b-amount">{{ (member.balance < 0 ? -member.balance : member.balance) |
                                    currency:'INR':'symbol':'1.0-2' }}</div>
                            </div>
                        </div>

                        <!-- Plan -->
                        <div class="section-header-row">
                            <div class="section-header header-no-margin">How to Settle</div>
                            <button mat-icon-button class="glass-btn-small" (click)="downloadSettlementReport()"
                                matTooltip="Download Settlement Report" *ngIf="settlements.length > 0">
                                <mat-icon>download</mat-icon>
                            </button>
                        </div>
                        <div class="settlement-list">
                            <div *ngFor="let plan of settlements" class="settlement-row">
                                <span class="s-name">{{ plan.fromName }}</span>
                                <div class="s-arrow">
                                    <span class="pay-label">pays</span>
                                    <span class="pay-amt">{{ plan.amount | currency:'INR':'symbol':'1.0-2' }}</span>
                                    <div class="arrow-line"></div>
                                    <mat-icon>arrow_right</mat-icon>
                                </div>
                                <span class="s-name">{{ plan.toName }}</span>
                            </div>
                        </div>
                        <div *ngIf="settlements.length === 0 && memberBalances.length > 0" class="empty-state">
                            <mat-icon class="large-empty-icon success-icon">check_circle</mat-icon>
                            <p>All settled up!</p>
                        </div>

                        <!-- Spending Breakdown -->
                        <div class="section-header-row">
                            <div class="section-header header-no-margin">Spending Breakdown</div>
                            <button mat-icon-button class="glass-btn-small" (click)="downloadBreakdownReport()"
                                matTooltip="Download Breakdown Report" *ngIf="memberBalances.length > 0">
                                <mat-icon>download</mat-icon>
                            </button>
                        </div>
                        <div class="breakdown-list">
                            <div *ngFor="let member of memberBalances" class="breakdown-row">
                                <div class="breakdown-user">
                                    <div class="member-avatar-small"
                                        [style.background-image]="member.photoURL ? 'url(' + member.photoURL + ')' : ''"
                                        [style.background-color]="member.photoURL ? 'transparent' : '#E0E7FF'">
                                        {{ member.photoURL ? '' : member.name.charAt(0) }}
                                    </div>
                                    <span class="user-name">{{ member.name }}</span>
                                </div>

                                <div class="breakdown-stats">
                                    <div class="stat-col">
                                        <span class="stat-label">Paid</span>
                                        <span class="stat-val positive">+{{ member.paid |
                                            currency:'INR':'symbol':'1.0-2' }}</span>
                                    </div>
                                    <div class="stat-col">
                                        <span class="stat-label">Share</span>
                                        <span class="stat-val neutral">{{ member.share | currency:'INR':'symbol':'1.0-2'
                                            }}</span>
                                    </div>
                                    <div class="stat-col">
                                        <span class="stat-label">Net</span>
                                        <span class="stat-val" [class.positive]="member.balance > 0"
                                            [class.negative]="member.balance < 0">
                                            {{ member.balance > 0 ? '+' : (member.balance < 0 ? '-' : '' ) }}{{
                                                (member.balance < 0 ? -member.balance : member.balance) |
                                                currency:'INR':'symbol':'1.0-2' }} </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            </mat-tab>
        </mat-tab-group>
    </div>
</div>